import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { HorizontalTimeline, TimelineElement } from "../generic/horizontal-timeline";
import { OnboardingCollectiviteResponse, MultipleFileRegistrationResponse, OnboardingSEMResponse } from "../../model/dto/response"
import { OnboardingCollectiviteWorkflow } from "../../model/entities/onboarding-collectivite-workflow"
import { SubscriptionCollectiviteFormIdentification } from "./subscription-collectivite-form-identification";
import { AuthenticationState } from "../../store/authentication/types";
import { ApplicationState } from "../../store";
import { referenceService } from "../../services/reference-service"
import { SubscriptionCollectiviteFormEnding } from "./subscription-collectivite-form-ending"
import { SubscriptionCollectiviteAdresses } from "./subscription-collectivite-adresses"
import { SubscriptionIdentiteRepresentantForm } from "./subscription-identite-representant-form";
import { CategorieEtablissement } from "../../model/entities/categorie-etablissement";
import { OnboardingSEMWorkflow } from "../../model/entities/onboarding-sem-workflow";
import { SubscriptionSEMFormBeneficiaires } from "./subscription-sem-form-beneficiaires";
import { OnboardingInvestisseurMoralPorteurProjetDocumentListForm } from "./onboarding-investisseur-moral-porteur-projet-document-list-form";

interface Props {
    onFinishOnboarding?: () => void,
    onSubmitIdentificationSuccess?: () => void
}

export function SubscriptionCollectiviteForm({onFinishOnboarding, onSubmitIdentificationSuccess}: Props) {
    const [isIdentiteDone, setIsIdentiteDone] = useState<boolean>(false)

    const onSubmitIdentification = (response: OnboardingCollectiviteResponse) => {
        if(onSubmitIdentificationSuccess) {
            onSubmitIdentificationSuccess()
        }

        setIsIdentiteDone(true)
    }

    if(!isIdentiteDone) {
        return (
            <div>
                <SubscriptionCollectiviteFormIdentification 
                    isOnboarding={true}
                    onSubmitSuccess={onSubmitIdentification}
                />
            </div>
        )
    }
    else {
        return (
            <SwitchOnboardingTypeEtablissement 
            />
        )
    }
}

type OnboardingCollectiviteCHUProps = {
    activeStepKey: string,
    onSubmitVerification: (response: OnboardingCollectiviteResponse) => void,
    onSubmitPiecesJustificatives: (response: MultipleFileRegistrationResponse) => void,
    onNextStep: (nextStepKey: string) => void
}

type SwitchOnboardingTypeEtablissementProps = {
}

function SwitchOnboardingTypeEtablissement({}: SwitchOnboardingTypeEtablissementProps) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)

    const [elements, setElements] = useState<TimelineElement[]>([])
    const [activeStepKey, setActiveStepKey] = useState<string>(loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.SOCIETE ? OnboardingSEMWorkflow.VERIFICATION : OnboardingCollectiviteWorkflow.VERIFICATION)

    useEffect(() => {
        if(loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.COLLECTIVITE || loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.CHU) {
            referenceService.getOnboardingCollectiviteWorkflowList(loginProps?.oauth)
            .then(response => {
                const workflowListRes: TimelineElement[] | undefined = response.OnboardingCollectiviteWorkflowList && response.OnboardingCollectiviteWorkflowList.map(res => {
                    return {
                        key: res.Code,
                        dataMainInfo: res.Libelle,
                        order:res.Order
                    } as TimelineElement
                })
                setElements(workflowListRes ?? [])
            })
        }
        else if(loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.SOCIETE) {
            referenceService.getOnboardingSEMWorkflowList(loginProps?.oauth)
            .then(response => {
                const workflowListRes: TimelineElement[] | undefined = response.OnboardingSEMWorkflowList && response.OnboardingSEMWorkflowList.map(res => {
                    return {
                        key: res.Code,
                        dataMainInfo: res.Libelle,
                        order:res.Order
                    } as TimelineElement
                })
                setElements(workflowListRes ?? [])
            })
        }
    }, [])
    
    if(loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.COLLECTIVITE || loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.CHU) {     
        const onNextStepSuccess = (response: OnboardingCollectiviteResponse) => {
            if(response.IsTraitementOk) {
                setActiveStepKey(response.NextStepKey!)
            }
        }

        const onSubmitPiecesJustificativesSuccess = (response: MultipleFileRegistrationResponse) => {
            if(response.IsTraitementOk) {
                setActiveStepKey(response.NextStepKey!)
            }
        }

        const onNextStep = (nextStepKey: string) => {
            setActiveStepKey(nextStepKey)
        }

        return (
            <>
                <HorizontalTimeline
                    elements={elements}
                    activeElementKey={activeStepKey}
                    lastElementKey={OnboardingCollectiviteWorkflow.COMPLET}
                    backgroundColor="#fff !important"
                />
                <OnboardingCollectiviteCHU
                    activeStepKey={activeStepKey}
                    onSubmitVerification={onNextStepSuccess}
                    onSubmitPiecesJustificatives={onSubmitPiecesJustificativesSuccess}
                    onNextStep={onNextStep}
                />
            </>
        )
    } else if(loginProps.user?.Etablissement?.CategorieCode === CategorieEtablissement.SOCIETE) {
        const onNextStepSuccess = (response: OnboardingSEMResponse) => {
            if(response.IsTraitementOk) {
                setActiveStepKey(response.NextStepKey!)
            }
        }

        const onSubmitPiecesJustificativesSuccess = (response: MultipleFileRegistrationResponse) => {
            if(response.IsTraitementOk) {
                setActiveStepKey(response.NextStepKey!)
            }
        }

        const onNextStep = (nextStepKey: string) => {
            setActiveStepKey(nextStepKey)
        }

        return (
            <>
                <HorizontalTimeline
                        elements={elements}
                        activeElementKey={activeStepKey}
                        lastElementKey={OnboardingSEMWorkflow.COMPLET}
                        backgroundColor="#fff !important"
                />
                <OnboardingSEM
                    activeElementKey={activeStepKey}
                    onNextStep={onNextStep}
                    onSubmitVerification={onNextStepSuccess}
                    onSubmitPiecesJustificatives={onSubmitPiecesJustificativesSuccess}
                />
            </>
        )
    }

    return (
        <>
        </>
    )
}

function OnboardingCollectiviteCHU({activeStepKey, onSubmitVerification, onSubmitPiecesJustificatives, onNextStep}: OnboardingCollectiviteCHUProps) {
    if(activeStepKey === OnboardingCollectiviteWorkflow.VERIFICATION) {
        return (
            <div>
                <SubscriptionIdentiteRepresentantForm
                    isOnboarding={true}
                    onSubmitSuccess={onSubmitVerification}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingCollectiviteWorkflow.ADRESSES)}
                />
            </div>
        )
    }

    if(activeStepKey === OnboardingCollectiviteWorkflow.ADRESSES) {
        return (
            <div>
                <SubscriptionCollectiviteAdresses
                    onSubmitSuccess={onSubmitVerification}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingCollectiviteWorkflow.PIECE_JUSTIFICATIVE)}
                />
            </div>
        )
    }

    if(activeStepKey === OnboardingCollectiviteWorkflow.PIECE_JUSTIFICATIVE) {
        return (
            <div>
                <OnboardingInvestisseurMoralPorteurProjetDocumentListForm 
                    onActionSuccess={onSubmitPiecesJustificatives}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingCollectiviteWorkflow.COMPLET)}
                    isOnboarding={true}
                />
            </div>
        )
    }

    if(activeStepKey === OnboardingCollectiviteWorkflow.COMPLET) {
        return (
            <div>
                <SubscriptionCollectiviteFormEnding />
            </div>
        )
    }

    return (
        <div></div>
    )
}

interface OnboardingSEMProps {
    activeElementKey: string,
    onNextStep: (nextStepKey: string) => void,
    onSubmitVerification: (response: Response) => void,
    onSubmitPiecesJustificatives: (response: Response) => void
}

function OnboardingSEM({activeElementKey, onNextStep, onSubmitVerification, onSubmitPiecesJustificatives}: OnboardingSEMProps) {   
    if(activeElementKey === OnboardingSEMWorkflow.VERIFICATION) {
        return (
            <div>
                <SubscriptionIdentiteRepresentantForm
                    isOnboarding={true}
                    onSubmitSuccess={onSubmitVerification}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingSEMWorkflow.ADRESSES)}
                />
            </div>
        )
    }

    if(activeElementKey === OnboardingSEMWorkflow.ADRESSES) {
        return (
            <div>
                <SubscriptionCollectiviteAdresses
                    onSubmitSuccess={onSubmitVerification}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingSEMWorkflow.PIECE_JUSTIFICATIVE)}
                />
            </div>
        )
    }

    if(activeElementKey === OnboardingSEMWorkflow.PIECE_JUSTIFICATIVE) {
        return (
            <div>
                <OnboardingInvestisseurMoralPorteurProjetDocumentListForm 
                    onActionSuccess={onSubmitPiecesJustificatives}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingSEMWorkflow.BENEFICIAIRES_EFFECTIFS)}
                    isOnboarding={true}
                />
            </div>
        )
    }

    if(activeElementKey === OnboardingSEMWorkflow.BENEFICIAIRES_EFFECTIFS) {
        return (
            <div>
                <SubscriptionSEMFormBeneficiaires 
                    onSubmitSuccess={onSubmitPiecesJustificatives}
                    onSkipStep={() => onNextStep && onNextStep(OnboardingSEMWorkflow.COMPLET)}
                    isOnboarding={true}
                />
            </div>
        )
    }

    if(activeElementKey === OnboardingSEMWorkflow.COMPLET) {
        return (
            <div>
                <SubscriptionCollectiviteFormEnding />
            </div>
        )
    }

    return (
        <div></div>
    )
}
